import React from 'react';
import { connect } from 'react-redux';
import { currencyFormatter } from 'utils/formatter';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { sendSignInContractClick } from 'actions/capital';
import * as clevertapCapital from 'clevertap/capital';
import styles from './Dashboard.css';

class Dashboard extends React.Component {
  render() {
    const { dashboardList } = this.props;
    const { showLoadingSpinnerPage } = this.props.loadingSpinner;
    return (
      <div className={styles.wrapper}>
        <NoDataAndLoading
          showLoadingSpinner={showLoadingSpinnerPage}
          noDataToDisplay={!dashboardList || dashboardList.length === 0}
          title="No data to display"
          description=""
        />
        <table
          className={`text-center table-responsive ${styles['table-header']}`}
        >
          <thead className={`${styles['thead-header']}`}>
            <tr className={`${styles['th-header']}`}>
              <th />
              <th>Lender</th>
              <th>Loan Amount</th>
              <th>Rate p.a</th>
              <th>Tenure</th>
              <th>Monthly Instalment</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody
            className={`${styles['no-padding']} ${styles['box-list']} ${
              styles['box-scroll']
            }`}
          >
            {dashboardList &&
              dashboardList.length > 0 &&
              dashboardList.map((loanApplication, index) => {
                const submission = {
                  tenure: loanApplication.tenor,
                  rate: loanApplication.rate,
                  amount: loanApplication.amount,
                  lender: loanApplication.lender.name,
                };
                return (
                  <tr className={`${styles['div-body']} spacer`} key={index}>
                    <td>
                      <img
                        src={loanApplication.lender.logo}
                        className={`${styles['logo-lender']}`}
                      />
                    </td>
                    <td>{loanApplication.lender.name}</td>
                    <td>
                      {Number.isFinite(Math.round(loanApplication.amount)) &&
                        currencyFormatter(Math.round(loanApplication.amount))}
                    </td>
                    <td>{loanApplication.rate}%</td>
                    <td>{loanApplication.tenor} months</td>
                    <td>
                      {Number.isFinite(
                        Math.round(loanApplication.monthly_installment)
                      ) &&
                        currencyFormatter(
                          Math.round(loanApplication.monthly_installment)
                        )}
                      /Month
                    </td>
                    <td
                      className={`${
                        loanApplication.status === 'Pending Approval'
                          ? styles['button-detail-lender-pending']
                          : loanApplication.status === 'Rejected' ||
                            loanApplication.status === 'Declined' ||
                            loanApplication.status === 'Expired'
                          ? styles['button-detail-lender-rejected']
                          : styles['button-detail-lender-approve']
                      }`}
                    >
                      {loanApplication.status.replace('_', ' ')}
                    </td>
                    <td>
                      {loanApplication.document.url && (
                        <a
                          target="_blank"
                          href={loanApplication.document.url}
                          className={styles['document-link']}
                          onClick={() =>
                            this._onClickSignContract(
                              loanApplication.document.id,
                              loanApplication.document.signed,
                              submission
                            )
                          }
                        >
                          {loanApplication.document.signed
                            ? 'View Contract'
                            : 'Sign Contract'}
                        </a>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    );
  }

  _onClickSignContract = (id, isSigned, submission) => {
    if (isSigned) {
      clevertapCapital.capitalClickViewContract(submission);
    } else {
      clevertapCapital.capitalClickContractSigned(submission);
    }

    this.props.dispatch(sendSignInContractClick(id, this.props.dashboardList));
  };
}

function mapStateToProps(state) {
  const { dashboardList } = state.capital;
  return {
    dashboardList,
    loadingSpinner: state.loadingSpinner,
  };
}

export default connect(mapStateToProps)(Dashboard);
